/**
 * NotFound Page
 * Displays when a route doesn't match any defined pages
 */
import { useLocation, Link } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="relative flex flex-col items-center justify-center min-h-screen text-center px-4 bg-background-50">
      <h1 className="absolute bottom-0 text-9xl md:text-[12rem] font-black text-background-200 select-none pointer-events-none z-0">
        404
      </h1>
      <div className="relative z-10">
        <h2 className="font-heading text-xl md:text-2xl font-semibold mt-6 text-foreground-900">
          Page Not Found
        </h2>
        <p className="mt-2 text-base text-secondary-500 font-body">{location.pathname}</p>
        <p className="mt-4 text-lg md:text-xl text-foreground-600 font-body">
          The page you are looking for does not exist.
        </p>
        <Link
          to="/"
          className="inline-flex items-center gap-2 mt-6 bg-primary-500 text-background-50 px-5 py-2.5 rounded-md font-body text-sm font-medium hover:bg-primary-600 transition-colors"
        >
          <i className="ri-arrow-left-line" />
          Back to Home
        </Link>
      </div>
    </div>
  );
}